module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"placeholder":"Schnellsuche: Projekt","deactivated":"deaktiviert","noresult":"Keine Projekte gefunden","new":"Neuen Kontakt hinzufügen"},"en":{"placeholder":"Fast search: project","deactivated":"deaktiviert","noresult":"No projects found","new":"Neuen Kontakt hinzufügen"}}')
  delete Component.options._Ctor
}
